import { initModalLinks } from './Modal/links';
import { initVideo } from "./Video/Video";
import initEmployeesList from "./Employees/EmployeesList";
import { initMediaCarousel } from "./MediaCarousel/MediaCarousel";
export default function () {
    initModalLinks();
    initVideo();
    initEmployeesList();
    initMediaCarousel();
}
